import { render, staticRenderFns } from "./list_h5.vue?vue&type=template&id=23e4df3a&scoped=true&"
import script from "./list_h5.vue?vue&type=script&lang=js&"
export * from "./list_h5.vue?vue&type=script&lang=js&"
import style0 from "./list_h5.vue?vue&type=style&index=0&id=23e4df3a&lang=less&scoped=true&"
import style1 from "./list_h5.vue?vue&type=style&index=1&id=23e4df3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e4df3a",
  null
  
)

export default component.exports